import { APIService, ArtTable, ArtTableHandle, confirmDialog, HeadCell, SSRTableBuilder, useApiService } from "@art/shared-ui"
import { usePageWrapper } from "../../../hooks"
import { useRef, useState } from "react";
import { ART_URL } from "../../../Constant";
import { useSearchParams } from "react-router-dom";
import { faFolderPlus, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import ResourceAccessDialog, { AccessCell, ResourceScope } from "./resource-access";
import { useAttributePermission } from "../../permissions";
import { tableParamNav } from "../../../utils/table-utils";

const InviteUser = () => {
    const [queryParams, setQueryParams]: any = useSearchParams();

    const apiService = useApiService();
    const tableRef = useRef<ArtTableHandle>(null);
    const canManageAccess = useAttributePermission("PLATFORM_SETTINGS", "USER_MANAGEMENT", "ManageResourceAccess");
    const canResendInvites = useAttributePermission("PLATFORM_SETTINGS", "USER_MANAGEMENT", "ResendInvitations");

    interface Data {
        id: string;
        receiver: string;
        status: string;
        resource_scopes: ResourceScope[];
    }
    const [accessInvite, setAccessInvite] = useState<Data | null>(null);

    const idpService = new APIService({
        ART_STORE: apiService.getStore(),
        BASE_URL: ART_URL + "/idp/api",
        DisableDefaultHeadder: true,
        DisableDefaultTenantUrl: true
    })

    const headCells: HeadCell<Data>[] = [
        {
            id: 'receiver',
            numeric: false,
            disablePadding: false,
            label: 'Email',
            getColData: (row) => row.receiver
        },
        {
            id: 'resource_scopes',
            numeric: false,
            disablePadding: false,
            label: 'Resource access',
            getColData: (row) => <AccessCell scopes={row.resource_scopes} />
        },
        {
            id: 'status',
            numeric: false,
            disablePadding: false,
            label: 'Invitation status',
            getColData: (row) => row.status === "complete"
                ? "Accepted"
                : row.status.charAt(0).toUpperCase() + row.status.slice(1)

        },
    ]

    const tableBuilder = SSRTableBuilder<Data>({
        endpoint: "/invites",
        method: "get",
        apiService: idpService,
        onFetch: (params) => {
            let currentPage = params["page"] || "1"
            let searchText = params["search_text"] || "" // search 

            //page and search added to params
            const newParams: any = {
                page: currentPage
            };
            if (searchText) {
                newParams.search = searchText;
            }
            setQueryParams(newParams, tableParamNav(queryParams, "page", currentPage));  // Update this

            return {
                "page": currentPage,
                "search_text": searchText
            }
        },
        onResponse: (data) => {
            return {
                data: data.data.data ?? [],
                total: data.data.total_count ?? 0,
            };
        }
    })

    const resendInvite = async (row: Data) => {
        try {
            await confirmDialog("confirm", `Resend the invite to ${row.receiver}?`);
        } catch {
            return; // cancelled
        }

        try {
            await idpService.post(`/invites/${row.id}/resend`, {});
            idpService.showSnack("Invite resent successfully", "success");
            tableRef.current?.refresh();
        } catch {
        }
    }

    return <>
        <ResourceAccessDialog email={accessInvite?.receiver || ""} existingScopes={accessInvite?.resource_scopes} open={!!accessInvite} onClose={() => setAccessInvite(null)} onSaved={() => tableRef.current?.refresh()} />
        <ArtTable ref={tableRef} headCells={headCells}
            builder={tableBuilder}
            rowActions={[
                ...(canResendInvites ? [{
                    icon: faPaperPlane,
                    label: "Resend Invite",
                    onClick: resendInvite
                }] : []),
                ...(canManageAccess ? [{ icon: faFolderPlus, label: "Manage project access", onClick: (row: Data) => setAccessInvite(row) }] : [])
            ]}
            // search={{ enabled: true, value: "" }}
            search={{
                enabled: true,
                value: queryParams.get("search") || "" // check and add the search text from params
            }}
            pagination={{
                initialPage: (parseInt(queryParams.get("page") || "1")) - 1
            }}

        />

    </>

}

export default usePageWrapper(InviteUser, {
    page_title: "Invites",
})
